module.exports = __webpack_public_path__ + "media/img/closedIcon-5b821d5d28cf4b8e64a9d1b161f1cd49.png";